import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agris-cotiz-detalle-pnjde-dialog',
  templateUrl: './agris-cotiz-detalle-pnjde-dialog.component.html',
  styleUrls: ['./agris-cotiz-detalle-pnjde-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgrisCotizDetallePnjdeDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-pnjde-dialog/agris-cotiz-detalle-pnjde-dialog.component.ts